/**
 * Temporary gate for Personal Notification Settings.
 * Set to `true` when deploying the Personal Settings feature to restore:
 * - Personal Settings tab
 * - /personal-settings route
 * - Profile "Configure Personal Notifications" link
 * - Notifications Settings entry for physician-only users
 */
export const IS_PERSONAL_NOTIFICATION_SETTINGS_ENABLED = false;
